<template>
  <div class="test-selection">
    <div class="page-header">
      <img src="@/assets/images/head.jpg" alt="页头图片" class="header-image">
    </div>
    <div class="header">
      <h1>六件事心理测试</h1>
      <p class="description">选择一个测试开始了解自己</p>
    </div>

    <div class="test-cards">
      <div class="test-card" @click="goToTest('twelve')">
        <div class="card-content">
          <h2>十二件事测试</h2>
          <p>通过12个维度全面评估您的心理状态和生活态度</p>
          <ul>
            <li>测试时长：约15-20分钟</li>
            <li>题目数量：60题</li>
            <li>测试结果：详细的多维度分析</li>
          </ul>
          <el-button type="primary" class="start-btn">开始测试</el-button>
        </div>
      </div>

      <div class="test-card" @click="goToTest('mbti')">
        <div class="card-content">
          <h2>MBTI性格测试</h2>
          <p>了解您的性格类型和潜在的职业发展方向</p>
          <ul>
            <li>测试时长：约20-25分钟</li>
            <li>题目数量：93题</li>
            <li>测试结果：16种性格类型分析</li>
          </ul>
          <el-button type="primary" class="start-btn">开始测试</el-button>
        </div>
      </div>
    </div>

    <div class="footer">
      <p>版权为
        <a href="https://www.shenchu2.com" target="_blank">
          佛山市顺德区乐从镇神出兔没广告设计部
        </a>
        所有
      </p>
      <p>
        <a href="https://beian.miit.gov.cn" target="_blank">
          粤ICP备18095156号
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestSelection',
  methods: {
    goToTest(type) {
      if (type === 'twelve') {
        this.$router.push('/twelve-test')
      } else if (type === 'mbti') {
        this.$router.push('/mbti-test')
      }
    }
  }
}
</script>

<style scoped>
.test-selection {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.test-selection .header {
  text-align: center;
  margin-bottom: 50px;
}

.test-selection .header h1 {
  font-size: 32px;
  color: #2c3e50;
  margin-bottom: 15px;
}

.test-selection .description {
  font-size: 18px;
  color: #666;
}

.test-selection .test-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  padding: 20px;
}

.test-selection .test-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: hidden;
}

.test-selection .test-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 25px rgba(0,0,0,0.12);
}

.test-selection .card-content {
  padding: 30px;
}

.test-selection .card-content h2 {
  font-size: 24px;
  color: #2c3e50;
  margin-bottom: 15px;
}

.test-selection .card-content p {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
}

.test-selection .card-content ul {
  list-style: none;
  padding: 0;
  margin-bottom: 25px;
}

.test-selection .card-content ul li {
  color: #666;
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
}

.test-selection .card-content ul li::before {
  content: "•";
  color: #409EFF;
  position: absolute;
  left: 0;
  font-size: 18px;
  line-height: 1;
}

.test-selection .start-btn {
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
  border-radius: 6px;
}

@media screen and (max-width: 768px) {
  .test-selection.test-selection {
    padding: 20px;
  }

  .test-selection .header h1 {
    font-size: 28px;
  }

  .test-selection .description {
    font-size: 16px;
  }

  .test-selection .test-cards {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 10px;
  }
}

.footer {
  text-align: center;
  padding: 20px 0;
  margin-top: 40px;
  border-top: 1px solid #eee;
  color: #666;
  font-size: 14px;
}

.footer p {
  margin: 5px 0;
}

.footer a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s;
}

.footer a:hover {
  color: #409EFF;
}

.page-header {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto 20px;
  text-align: center;
}

.header-image {
  width: auto;
  height: auto;
  max-height: 250px;
  max-width: 100%;
  display: block;
  object-fit: contain;
  margin: 0 auto;
}
</style> 